'use client';

import ReactDOM from 'react-dom';

export const PreloadResources = () => {
  ReactDOM.preconnect('https://a.storyblok.com');

  return null;
};
